import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { CourceClinicOptionFilters } from './CourceClinicOptionFilters';

toast.configure();
export const CourceClinic = memo((props) => {
  const { item, options } = props;

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  return (
    <tr>
      <td>{item.id}</td>
      <td>{item.clinic_id}</td>
      <td>{item.clinic_name}</td>
      <td>
        <CourceClinicOptionFilters
          cource_clinic_id={item.id}
          options={options}
          using_option_ids={item.using_option_ids} />
      </td>
    </tr>
  );
});
